import { Grid, useMediaQuery } from "@mui/material";
import { DateField, Labeled, TextField, useRecordContext } from "react-admin";

import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";

const InterviewSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();

  if (!record?.interview) return null;

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Интервю"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Начало">
            <DateField
              showTime
              source="interview.start"
              locales="bg-BG"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Край">
            <DateField
              showTime
              source="interview.end"
              locales="bg-BG"
              emptyText="-"
            />
          </Labeled>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Бележка">
            <TextField
              source="interview.notes"
              emptyText="-"
            />
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default InterviewSection;
